import { $, $$ } from 'src/shared/js/utils/dom';
import AniScroll from 'src/shared/js/modules/ani-scroll';
import { initAccordion } from '../../0-atoms/accordion/accordion';

class JumpMarks {
  constructor(option) {
    this.container = option.container;
    this.accordion = option.accordion;
    this.handler = $('.accordion__trigger', this.container);
    this.buttonNext = $('.accordion__button--next', this.container);
    this.buttonPrev = $('.accordion__button--prev', this.container);
    this.links = $$('.accordion__link', this.container);
    this.currentTextElement = $(
      '.jumpmarks span:first-of-type',
      this.container
    );
    this.targetElementList = this.getTargetElementList();
    this.index = null;
    this.INITIAL_TEXT = this.currentTextElement.innerText;
  }

  getTargetElementList() {
    const targetElementList = this.links
      .map(link => {
        const targetElement = $(link.hash);
        // debug with
        // targetElement.style.outline = '1px solid red';
        if (!targetElement) {
          console.warn(
            `element for jumpmark target ${link.hash} does not exist`
          );
        }
        return targetElement;
      })
      .filter(Boolean);

    return targetElementList;
  }

  getCurrentIndex() {
    const currentActiveLink = $('a.is-active-jumpmark', this.container);
    return this.links.indexOf(currentActiveLink);
  }

  forceCloseAccordion() {
    // closes the accordion without transition
    // it's a bit hacky
    // maybe the accordion itself should support this feature?
    const hasReducedMotion = this.accordion.hasReducedMotion;
    const duration = this.accordion.duration;
    this.accordion.hasReducedMotion = true;
    this.accordion.duration = 0;
    this.accordion.setInitialProps();
    this.accordion.close();
    this.accordion.hasReducedMotion = hasReducedMotion;
    this.accordion.duration = duration;
    this.accordion.setInitialProps();
  }

  setActiveState(id) {
    const activeLink = this.links.find(
      link => link.getAttribute('href') === `#${id}`
    );

    // updateCurrentText
    this.currentTextElement.innerText = activeLink.innerText.trim();

    // updateActiveClass
    this.links.forEach(link => link.classList.remove('is-active-jumpmark'));
    activeLink.classList.add('is-active-jumpmark');

    this.index = this.getCurrentIndex();

    // updateButtons
    const isLastIndex = this.index === this.links.length - 1;
    const isFirstIndex = this.index === this.links.indexOf(this.links[0]);

    this.buttonNext.disabled = isLastIndex;
    this.buttonPrev.disabled = isFirstIndex;
  }

  resetActiveState() {
    this.currentTextElement.innerText = this.INITIAL_TEXT;

    // when at the top, there can be no active jumpmarks
    this.links.forEach(link => {
      link.classList.remove('is-active-jumpmark');
    });
  }

  setFixed(isFixed) {
    // because we call it everytime the observer detects an intersection
    // we need to check if the jumpmarks are already fixed
    // else we woulc close the accordion unnecessarily
    if (this.container.classList.contains('jumpmarks--is-fixed') === isFixed)
      return;

    // close the accordion, because an open one would be unexpected
    this.forceCloseAccordion();
    // and position the jumpmarks fixed
    this.container.classList[isFixed ? 'add' : 'remove']('jumpmarks--is-fixed');
  }

  manageScrollTriggers() {
    const targetElementList = this.targetElementList;

    const options = {
      threshold: 0,
      rootMargin: '-20% 0% -80% 0%',
    };

    targetElementList.length &&
      targetElementList.forEach((target, index) => {
        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            this.setFixed(true);

            const targetElement = entry.target;
            this.setActiveState(targetElement.id);
          } else {
            const isFirst = index === 0;
            const isLast = index === targetElementList.length - 1;
            const isScrollingDown = entry.boundingClientRect.top < 0;

            if (
              (isFirst && !isScrollingDown) ||
              (isLast && isScrollingDown) ||
              window.scrollY <= this.container.offsetTop
            ) {
              this.setFixed(false);
              this.resetActiveState();
            }
          }
        }, options);
        this.observer.observe(target);
      });
  }

  scrollTo(newIndex) {
    this.index = newIndex;
    const targetLink = this.links[this.index];
    targetLink.click() && this.jumpToAnchor(targetLink);
  }

  moveForward() {
    const targetIndex = this.index + 1;

    if (targetIndex > this.links.length - 1) return;

    this.scrollTo(targetIndex);
  }

  moveBackward() {
    const targetIndex = this.index - 1;

    if (targetIndex < 0) return;

    this.scrollTo(targetIndex);
  }

  jumpToAnchor(event) {
    const targetId = event.currentTarget.hash;
    const targetPath = event.currentTarget.pathname;
    const target = $(targetId);
    let scrollToPosition = null;

    if (target && window.location.pathname === targetPath) {
      scrollToPosition = target.offsetTop - 50;

      AniScroll(scrollToPosition, 500, 'easeOutQuad', () => {
        target.setAttribute('tabindex', '0');
        target.focus();
      });
    } else {
      console.error(`element ${target} does not exist on that page`);
    }

    if (this.accordion.handler.classList.contains('is-open')) {
      this.handler.click();
    }
  }

  bindEvents() {
    this.links.forEach(link => {
      link.addEventListener('click', this.jumpToAnchor.bind(this));
    });

    this.buttonNext.addEventListener('click', this.moveForward.bind(this));
    this.buttonPrev.addEventListener('click', this.moveBackward.bind(this));
  }

  init() {
    this.bindEvents();
    this.manageScrollTriggers();
  }
}

const jumpMarksList = $$('.jumpmarks');
const accordionItems = $$('.accordion');
let accordionInstance = null;

// responsible for the dropdown panel only
accordionItems.length &&
  accordionItems.forEach(accordionItem => {
    accordionInstance = initAccordion(accordionItem);
  });

// responsible for all the rest features
jumpMarksList.length &&
  jumpMarksList.forEach(jumpMark => {
    new JumpMarks({
      container: jumpMark,
      accordion: accordionInstance,
    }).init();
  });
